import { motion } from "framer-motion";
import ChapterMarker from "../ChapterMarker";
import { PROFILE, SECTIONS } from "../../data/content";

export default function About() {
  const s = SECTIONS[1];
  return (
    <section
      id={s.id}
      style={{ minHeight: `${s.weight * 100}vh` }}
      className="relative flex items-center px-6 md:px-12 lg:px-24"
      data-testid="section-about"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-15%" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="pointer-events-auto max-w-xl border border-[#01FFFF]/20 bg-[#0A0A12]/60 backdrop-blur-xl p-8 md:p-12"
      >
        <ChapterMarker number={s.number} label={s.label} />
        <h2 className="font-heading text-3xl md:text-4xl uppercase tracking-tight text-[#E0E6ED]">
          {PROFILE.name}
        </h2>
        <p className="mt-5 font-mono text-sm leading-relaxed text-[#8A9AAB]" data-testid="about-summary">
          {PROFILE.summary}
        </p>
        <p className="mt-6 font-mono text-xs tracking-widest text-[#01FFFF]">
          BASE: {PROFILE.location.toUpperCase()}
        </p>
      </motion.div>
    </section>
  );
}
